import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import _isEmpty from 'lodash/isEmpty';

import { Card } from 'components/Card';
import LoadingDots from 'components/LoadingDots';
import Message from 'components/Message';
import RatingsSummaryItem from './RatingsSummaryItem';

import './RatingsSummary.scss';

const messages = defineMessages({
  instructors: {
    id: 'ratings.ratings-summary.instructors',
    defaultMessage: 'Staff',
  },
});

const InstructorsRatingsSummaryLoader = () => (
  <Card className="pb-r" flush>
    <p className="grid__item 1/1 ratings-summary__header">
      <Message message={messages.instructors} />
    </p>
    <div className="ratings-summary__loader">
      <LoadingDots />
    </div>
  </Card>
);

const InstructorsRatingsSummary = ({ instructorsRatings, isLoading, updateInstructor }) => {
  if (isLoading) return <InstructorsRatingsSummaryLoader />;
  if (_isEmpty(instructorsRatings)) return null;

  return (
    <Card flush>
      <p className="grid__item 1/1 ratings-summary__header">
        <Message message={messages.instructors} />
      </p>
      {instructorsRatings.map(({ instructorId, instructorName, ratingsCount, averageRating }) => (
        <RatingsSummaryItem
          key={instructorId}
          id={instructorId}
          title={instructorName}
          ratingsCount={ratingsCount}
          averageRating={averageRating}
          onViewClick={updateInstructor}
        />
      ))}
    </Card>
  );
};

InstructorsRatingsSummary.propTypes = {
  instructorsRatings: PropTypes.arrayOf(
    PropTypes.shape({
      ratingsCount: PropTypes.number,
      averageRating: PropTypes.number,
      instructorName: PropTypes.string,
      instructorId: PropTypes.number,
    })
  ),
  updateInstructor: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default InstructorsRatingsSummary;
